import { useEffect, useState } from "react";

/**
 * Chart-style crosshair cursor: full-bleed hairlines, a gapped plus mark and a
 * black price tag pinned to the right edge of the horizontal hairline.
 * Desktop only; coarse pointers keep the native cursor.
 */
export function Crosshair() {
  const [pos, setPos] = useState<{ x: number; y: number } | null>(null);

  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;

    document.body.classList.add("crosshair-on");
    const onMove = (e: MouseEvent) => setPos({ x: e.clientX, y: e.clientY });
    const onLeave = () => setPos(null);

    window.addEventListener("mousemove", onMove, { passive: true });
    document.addEventListener("mouseleave", onLeave);
    return () => {
      document.body.classList.remove("crosshair-on");
      window.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseleave", onLeave);
    };
  }, []);

  if (!pos) return null;

  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-[60]">
      <span
        className="absolute top-0 h-full w-px bg-ink/25"
        style={{ left: pos.x }}
      />
      <span
        className="absolute left-0 h-px w-full bg-ink/25"
        style={{ top: pos.y }}
      />

      {/* Bold plus mark centered on the pointer, with light halo for contrast */}
      <span
        className="absolute"
        style={{ left: pos.x, top: pos.y, transform: "translate(-50%, -50%)" }}
      >
        <svg
          width="19"
          height="19"
          viewBox="0 0 19 19"
          style={{ display: "block", transform: "translate(-50%, -50%)" }}
        >
          <path
            d="M9.5 1 V18 M1 9.5 H18"
            stroke="var(--bg)"
            strokeWidth="5"
            strokeLinecap="butt"
          />
          <path
            d="M9.5 1 V18 M1 9.5 H18"
            stroke="var(--ink)"
            strokeWidth="3"
            strokeLinecap="butt"
          />
        </svg>
      </span>
    </div>
  );
}

